import { EmailTemplateService } from './../../../../services/EmailTemplate.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EActionTypes, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';

@Component({
    selector: 'app-ops-neworedit-email-template',
    imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, NgxEditorComponent, NgxEditorMenuComponent, FormsModule,
        UserPermissionHandlerDirective
    ],
    templateUrl: './ops-neworedit-email-template.html',
    styleUrl: './ops-neworedit-email-template.scss',
})
export class OpsNeworeditEmailTemplate {
    html = '';
    editor: Editor;
    toolbar: Toolbar = [
        // default value
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
        ['link', 'image'],
        // or, set options for link:
        //[{ link: { showOpenInNewTab: false } }, 'image'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
        ['horizontal_rule', 'format_clear', 'indent', 'outdent'],
        ['superscript', 'subscript'],
        ['undo', 'redo'],
    ];

    private subscriptions: Subscription[] = [];

    response: any;
    @Output() close = new EventEmitter<void>();

    EmailTemplateForm: FormGroup;
    loaderIcon: Promise<boolean>;
    MergeFields: any[];
    baseTemplateTypes: any[];
    public BaseTemplateDropdownFields: Object = { text: 'BaseTemplateName', value: 'baseTemplateType' };
    public MergeDropDownfields: Object = { text: 'MergeText', value: 'MergeValue' };

    @Input() templateData: any;
    EmailTemplateDetails: any;
    MergeFieldForm: FormGroup;
    isEditMode = false;

    createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.CREATE };
    editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Email Templates'], Action: EActionTypes.EDIT };

    constructor(private formBuilder: FormBuilder,
        private EmailTemplateService: EmailTemplateService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private toastr: ToastrService,
        private sharedHTMLSettings: SharedHTMLSettingsDataService
    ) {
        this.MergeFieldForm = this.formBuilder.group({
            selectedField: [''] // Initialize the form control with an empty string
        });

        this.EmailTemplateForm = this.formBuilder.group({
            Id: [0],
            baseTemplateType: [0, [Validators.required]],
            type: [0, [Validators.required]],
            templateName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(40)]],
            templateContent: ['', [Validators.minLength(2), Validators.maxLength(10000)]],
            Subject: ['']
        });


    }

    ngOnInit(): void {
        this.editor = new Editor();

        this.GetAllMergeFieldList();

        this.subscriptions.push(this.EmailTemplateService.GetAllBaseTemplateTypeList().subscribe((res: any) => {
            this.baseTemplateTypes = [];
            res.map((el, i) => {
                const ob = {
                    baseTemplateType: el.Id,
                    BaseTemplateName: el.BaseTemplateName,
                    BaseTemplateContent: el.BaseTemplateContent,
                    Subject: el.Subject
                }
                this.baseTemplateTypes.push(ob);

            });
        }, err => {
            this.toastr.error($localize`Base Template Required `, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)

        }));

        if (this.templateData != null) {
            this.getEmailTemplateById(this.templateData.Id)
        }

    }

    getEmailTemplateById(id) {
        this.loaderIcon = Promise.resolve(true);
        this.subscriptions.push(this.EmailTemplateService.GetEmailTemplateById(id).subscribe((response: any) => {

            this.EmailTemplateDetails = response.body;
            if (response) {
                this.EmailTemplateForm.patchValue({
                    templateContent: this.EmailTemplateDetails.TemplateContent,
                    type: this.EmailTemplateDetails.Type,
                    templateName: this.EmailTemplateDetails.TemplateName,
                    baseTemplateType: this.EmailTemplateDetails.BaseTemplateId,
                    Id: this.EmailTemplateDetails.EmailTemplateId,
                    Subject: this.EmailTemplateDetails.Subject
                });
                this.isEditMode = true;
            } else {
                this.toastr.error($localize`template not found`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            }
            this.loaderIcon = Promise.resolve(false);
        }));
    }

    GetAllMergeFieldList() {

        this.loaderIcon = Promise.resolve(true);
        this.MergeFields = [{
            MergeText: "Select MergeField",
            MergeValue: null,
        }];
        this.subscriptions.push(this.EmailTemplateService.GetAllMergeFieldList().subscribe((res: any) => {
            res.map((el, i) => {
                const ob = {
                    MergeText: el.MergeFieldName,
                    MergeValue: el.MergeFieldName,
                }
                this.MergeFields.push(ob);
            });

            this.loaderIcon = Promise.resolve(false);
        }));

        this.loaderIcon = Promise.resolve(false);
    }

    GetselectedBaseTemplate(ID) {
        const typeid = this.EmailTemplateForm.get('baseTemplateType').value;

    }


    //    MergeFieldSelected() {
    //         const selectedField = this.MergeFieldForm.get('selectedField')?.value;
    //         if (!selectedField) return;

    //         const fieldText = ` ${selectedField} `;

    //         if (this.editor && this.editor.commands) {
    //             // Insert text at current cursor position
    //             this.editor.commands.insertText(fieldText);
    //         }

    //         // Reset selected field after inserting
    //         this.MergeFieldForm.patchValue({
    //             selectedField: ''
    //         });
    //     }

    MergeFieldSelected() {
        const selectedField = this.MergeFieldForm.get('selectedField')?.value;
        if (!selectedField || !this.editor) return;
        const view = this.editor.view; // EditorView instance
        if (!view) return;
        const { state, dispatch } = view;
        const { from, to } = state.selection; // current cursor position / selection range
        // Build a transaction to insert text
        const transaction = state.tr.insertText(` ${selectedField} `, from, to);
        dispatch(transaction); // apply the transaction
        view.focus();
        this.MergeFieldForm.patchValue({ selectedField: '' });
    }

    CloseEditOrNew() {
        this.close.emit();
    }

    SaveOrUpdateTemplate() {

        this.loaderIcon = Promise.resolve(true);
        if (this.EmailTemplateForm.value['type'] == 0) {
            this.toastr.error($localize`Select template type`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
            return;
        }

        if (this.EmailTemplateForm.value['templateName'].trim() == '') {
            this.toastr.error($localize`Enter template name`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
            return;
        }

        if (this.EmailTemplateForm.value['baseTemplateType'] == 0) {
            this.toastr.error($localize`Select base template`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
            return;
        }

        if (this.EmailTemplateForm.valid) {
            const cpmodel = {
                EmailTemplateId: this.EmailTemplateForm.value['Id'],
                TemplateName: this.EmailTemplateForm.value['templateName'],
                Type: this.EmailTemplateForm.value['type'],
                BaseTemplateId: this.EmailTemplateForm.value['baseTemplateType'],
                BaseTemplate: '',
                TemplateContent: this.EmailTemplateForm.value['templateContent'],
                CreatedDateTime: null,
                UserId: 0,
                Subject: this.EmailTemplateForm.value['Subject']
            };

            this.subscriptions.push(this.EmailTemplateService.UpdateOrSaveEmailTemplate(cpmodel).subscribe({
                next: (res: any) => {
                    if (res?.Success === true) {
                        this.toastr.success(res.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
                        this.CloseEditOrNew();
                    } else {
                        this.toastr.error(res?.Message || 'Save was Unsuccessful', $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                    }
                    this.loaderIcon = Promise.resolve(false);
                },
                error: (err) => {
                    this.toastr.error($localize`Save was Unsuccessful`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                    this.loaderIcon = Promise.resolve(false);
                }
            }));
            this.loaderIcon = Promise.resolve(false);
        } else {
            if (this.EmailTemplateForm.controls['templateContent'].hasError('maxlength')) {
                this.toastr.warning('Email content cannot exceed 10,000 characters.', $localize`Warning`, this.sharedHTMLSettings.ToasterConfig)
                this.loaderIcon = Promise.resolve(false);
            } else {
                this.toastr.error('Please check the form', $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
                this.loaderIcon = Promise.resolve(false);
            }
        }
    }

    ngOnDestroy(): void {
        this.editor.destroy();
        this.subscriptions.forEach((subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }

}
